import type { DSBaseListOption, DSListOptions, DSOptionListModelValue, DSSListOptionGroup } from "../types";

export const isOptionGroup = (item: DSBaseListOption | DSSListOptionGroup): item is DSSListOptionGroup => {
  return "options" in item;
};

export const flattenOptions = (options: DSListOptions): DSBaseListOption[] => {
  return options.flatMap(item => (isOptionGroup(item) ? item.options : [item]));
};

export const getOptionId = (listIdPrefix: string, option: DSBaseListOption): string => {
  const safeValue = String(option.value ?? "null").replace(/\s+/g, "-");
  return `${listIdPrefix}--opt-${safeValue}`;
};

export const findOptionById = (
  listIdPrefix: string,
  flatOptions: DSBaseListOption[],
  id: string
): DSBaseListOption | undefined => {
  return flatOptions.find(option => getOptionId(listIdPrefix, option) === id);
};

export const normalizeModelValue = (modelValue: DSOptionListModelValue | undefined): (string | null)[] => {
  if (!modelValue) return [];
  return Array.isArray(modelValue) ? modelValue : [modelValue];
};
